<template>
    <div>
        <Navbar/>

        <div class="section section-color center">
            <div class="w-container">
                <div class="key-number">{{$t('support')}}</div>
            </div>
        </div>

        <div class="page-content">
            <div class="help-text">
                If you have a question about LocalScale or need help setting up your ad, please contact us by writing a message in the field below.
                A member of the LocalScale support team will get back to you within 24 hours.
            </div>

            <form id="supportForm" autocomplete="on" method="POST" action="https://ut9um6yb3j.execute-api.us-east-1.amazonaws.com/contact-us/localscale-contact-us-form-handler">
                <input type="hidden" name="Page" value="Support">
                <input type="hidden" name="Name" :value="user.name">
                <input type="hidden" name="Email Address" :value="user.email_address">
                <input type="hidden" name="Company" :value="user.company">

                <b-field :label="$t('message') + ' *'">
                    <b-input type="textarea" name="Message" required></b-input>
                </b-field>

                <div class="button-container">
                    <button class="ds-button button-small w-button" id="submit-button" type="submit">{{$t('submit')}}</button>
                </div>
            </form>
        </div>

        <Footer/>
    </div>
</template>

<style>
    .help-text {
        margin-bottom: 30px;
    }
    @media (max-width: 479px) {
        .page-content {
            margin: 0 20px 0 20px;
            width: 330px;
        }
    }
</style>

<script>
    import Navbar from "../components/Navbar";
    import Footer from "../components/Footer";
    import session from '../session'

    session.checkSession();

    const model = {
        user: {
            name: null,
            email_address: null,
            company: null,
        },
        message: null
    };

    function getUserNameSuccessHandler(responseData) {
        model.user.name = responseData.full_name;
        model.user.email_address = responseData.email_address;
    }

    function getUserSuccessHandler(responseData) {
        model.user.company = responseData.company;
    }

    function errorHandler() {
    }

    session.get('fullname', getUserNameSuccessHandler, errorHandler, []);
    session.get('user', getUserSuccessHandler, errorHandler, []);

    export default {
        components: {
            Navbar, Footer
        },

        data() {
            return model;
        }
    }
</script>
